import abnormalDetail from '@/pages/bigAftersale/abnormal-detail'
import aftersaleDetail from '@/pages/bigAftersale/aftersale-detail'
import afterSaleManage from '@/pages/bigAftersale/aftersale-manage'
import afterSaleInputTs from '@/pages/bigAftersale/aftersalse-input-ts'
import afterSaleShippingList from '@/pages/bigAftersale/aftersale-shipping-list'
const afterSaleRouter =
[
  {
    path: '/bigAftersale/manage',
    component: afterSaleManage,
    name: 'bigafterSaleManage',
    meta: {roles: ['pingtai', 'zhifa','factory', 'r4gys'], title: '售后大单'}
  },
  {
    path: '/bigAftersale/abnormal/detail',
    component: abnormalDetail,
    name: 'bigabnormalDetail',
    hidden: true,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigAftersale/shippingList',
    component: afterSaleShippingList,
    name: 'bigafterSaleShippingList',
    hidden: true,
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigAftersale/detail',
    component: aftersaleDetail,
    hidden: true,
    name: 'bigafterSaleDetail',
    meta: {roles: ['shop', 'r4gys']}
  },
  {
    path: '/bigAftersale/afterSaleInputTs',
    component: afterSaleInputTs,
    hidden: true,
    name: 'bigafterSaleInputTs',
    meta: {roles: ['shop', 'r4gys']}
  }
]

export default afterSaleRouter



// WEBPACK FOOTER //
// ./src/router/modules/bigAftersaleRouter.js